<template>
  <v-alert
    dense
    class="ma-0 orange--text text--darken-3"
    color="orange lighten-5"
    type="warning"
    :icon="false"
  >
    <v-row align="center">
      <v-col class="grow pt-0 pb-0 text-xs-left">
        <v-icon color="orange darken-3">warning</v-icon>
        Доступна нова версія
      </v-col>
      <v-col class="shrink pt-0 pb-0">
        <DocumentBlockVersionMenu
          :value="value"
          @apply="
            (versionId) => {
              $emit('apply', versionId);
            }
          "
        />
      </v-col>
      <v-col class="shrink pl-0 pt-0 pb-0">
        <v-btn color="grey" icon small class="pa-0" @click="$emit('decline')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>
<script>
import DocumentBlockVersionMenu from "../document-blocks/DocumentBlockVersionMenu.vue";
export default {
  components: {
    DocumentBlockVersionMenu,
  },
  props: ["value"],
};
</script>
